module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "vol-1-chapter-19"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "vol-1-chapter-19-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("19")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-19-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("hree days had passed since the so-called ‘situation’ outside his house. Black had decided against contacting the police. He had stabbed a key in a man’s eye and vandalised his car. It didn’t look good. He thought it prudent to let that one pass. And he was secure in the knowledge that his victim would do the same.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But they knew where he lived. They knew he was married and had a four-year-old daughter. Christ, they knew her name. Grant had sent a message, and Black had sent one back. That he was not scared of them. That he could administer casual violence as easily as them. But Jennifer and Merryn were in the equation, and the stakes had never been higher. They could hide away, but for how long? And how could they live like that, scurrying through life like frightened animals? Looking over their shoulder, every minute, every second.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There was no easy solution. They had to continue their routine, go about their normal lives. Merryn was too young to understand what was going on. Jennifer was terrified. She didn’t say, but Black knew she was, and who could blame her? And there was nothing he could do about it. For the first time in his life, he felt ineffectual. He had suggested she take an extended break from work – she was more than due it – and she and Merryn stay with her mother in her big house in Thurso, over one hundred miles north of Inverness, as about as far north as most people go. But he had only suggested it tentatively, and she had flatly refused, which was the best thing, reflected Black. Grant was clearly resourceful. He would find out where she’d gone. And if that happened, Black was nearly three hundred miles away to do anything about it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black restructured his hours, left the house in the morning when Jennifer and Merryn left, and got back early, taking files home. They stayed in during the evening and watched television, read books.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Life went on. For three days. Then it began.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The unravelling of Black’s life.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4d7d74a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001chapter019.vue
// module id = 129
// module chunks = 0